import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../../api";

const CourseresultReports = () => {
  const location = useLocation();
  const { usercourseid, coursecode, coursename, academicYear, semester,teacher_name } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // Course result data
  const [averagesdata, setAveragesData] = useState([]); // Averages data

  // Fetch course result data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/reports/getcourseresult/${usercourseid}`,{academicYear});
        setData(res.data);
      } catch (err) {
        console.error("Error fetching course result data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [usercourseid]);

  // Fetch averages data
  useEffect(() => {
    const fetchAverages = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/reports/getaverages/${usercourseid}`);
        setAveragesData(res.data);
      } catch (err) {
        console.error("Error fetching averages data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAverages();
  }, [usercourseid]);

  return (
    <div className="p-6 max-w-4xl mx-auto mt-8">
      <h1 className="text-2xl font-bold text-center mb-6">Course Result Reports</h1>

      {/* Course Details */}
      {usercourseid ? (
        <div className="bg-white p-4 rounded-lg shadow-md mb-6">
          <h2 className="text-lg font-semibold mb-4">Course Details:</h2>
          <ul className="space-y-2 text-gray-700">
            <li><strong>Course Code:</strong> {coursecode}</li>
            <li><strong>Course Name:</strong> {coursename}</li>
            <li><strong>Academic Year:</strong> {academicYear}</li>
            <li><strong>Semester:</strong> {semester}</li>
            <li><strong>Teacher Name:</strong> {teacher_name}</li>
          </ul>
        </div>
      ) : (
        <p className="text-center text-gray-500">No course data available.</p>
      )}

      {/* Table */}
      {loading ? (
        <p className="text-blue-500 text-center">Loading data...</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left border border-gray-200 rounded-lg">
            <thead className="bg-purple-800 text-white">
              <tr>
                <th className="py-2 px-4">CO Name</th>
                <th className="py-2 px-4">PO 1</th>
                <th className="py-2 px-4">PO 2</th>
                <th className="py-2 px-4">PO 3</th>
                <th className="py-2 px-4">PO 4</th>
                <th className="py-2 px-4">PO 5</th>
                <th className="py-2 px-4">PO 6</th>
                <th className="py-2 px-4">PO 7</th>
                <th className="py-2 px-4">PO 8</th>
                <th className="py-2 px-4">PO 9</th>
                <th className="py-2 px-4">PO 10</th>
                <th className="py-2 px-4">PO 11</th>
                <th className="py-2 px-4">PO 12</th>
                <th className="py-2 px-4">PSO 1</th>
                <th className="py-2 px-4">PSO 2</th>

              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index} className={`${index % 2 === 0 ? "bg-purple-50" : "bg-white"}`}>
                  <td className="py-2 px-4">{item.co_name}</td>
                  <td className="py-2 px-4">{item.po_1 || "-"}</td>
                  <td className="py-2 px-4">{item.po_2 || "-"}</td>
                  <td className="py-2 px-4">{item.po_3 || "-"}</td>
                  <td className="py-2 px-4">{item.po_4 || "-"}</td>
                  <td className="py-2 px-4">{item.po_5 || "-"}</td>
                  <td className="py-2 px-4">{item.po_6 || "-"}</td>
                  <td className="py-2 px-4">{item.po_7 || "-"}</td>
                  <td className="py-2 px-4">{item.po_8 || "-"}</td>
                  <td className="py-2 px-4">{item.po_9 || "-"}</td>
                  <td className="py-2 px-4">{item.po_10 || "-"}</td>
                  <td className="py-2 px-4">{item.po_11|| "-"}</td>
                  <td className="py-2 px-4">{item.po_12 || "-"}</td>
                  <td className="py-2 px-4">{item.pso_1|| "-"}</td>
                  <td className="py-2 px-4">{item.pso_1 || "-"}</td>
                </tr>
              ))}
              {averagesdata.map((avg, index) => (
                <tr
                  key={`avg-${index}`}
                  className="bg-purple-100 font-semibold text-gray-700"
                >
                  <td className="py-2 px-4">Average</td>
                  <td className="py-2 px-4">{avg.po_1 || "-"}</td>
                  <td className="py-2 px-4">{avg.po_2 || "-"}</td>
                  <td className="py-2 px-4">{avg.po_3 || "-"}</td>
                  <td className="py-2 px-4">{avg.po_4 || "-"}</td>
                  <td className="py-2 px-4">{avg.po_5 || "-"}</td>
                  <td className="py-2 px-4">{avg.po_7 || "-"}</td>
                  <td className="py-2 px-4">{avg.po_6 || "-"}</td>
                  <td className="py-2 px-4">{avg.po_8 || "-"}</td>
                  <td className="py-2 px-4">{avg.po_9 || "-"}</td>
                  <td className="py-2 px-4">{avg.po_10 || "-"}</td>
                  <td className="py-2 px-4">{avg.po_11|| "-"}</td>
                  <td className="py-2 px-4">{avg.po_12 || "-"}</td>
                  <td className="py-2 px-4">{avg.pso_1|| "-"}</td>
                  <td className="py-2 px-4">{avg.pso_1|| "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CourseresultReports;
